import React, { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import logoeasycampus from "../../public/images/logo-easycampus.png";
import { capitalizeFirstLetter, dateFormatForUser } from '@/utils/common';
import Link from 'next/link';
import Image from 'next/image';
import { LastBlogDetails } from '../common/loaderasdata';

const LastBlog = ({blogs,loading}) => {
  const [isLoading, setIsLoading] = useState(true);

    const decodeHtml = (html) => {
        if (typeof window !== "undefined") {
          const txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
        }
        // Return the input as is if running on the server
        return html;
      };
    
      function truncateHtml(html, maxLength) {
        if (typeof window === "undefined") {
          // If running on the server, return the plain HTML as is or handle it differently
          return html?.substring(0, maxLength) || "";
         //return html;
          
        }
      
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        let truncated = "";
        let charCount = 0;
      
        const traverseNodes = (node) => {
          if (charCount >= maxLength) return;
      
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            if (charCount + text.length > maxLength) {
              truncated += text.substring(0, maxLength - charCount);
              charCount = maxLength;
            } else {
              truncated += text;
              charCount += text.length;
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            truncated += `<${node.tagName.toLowerCase()}${
              node.getAttribute("style")
                ? ` style="${node.getAttribute("style")}"`
                : ""
            }>`;
            for (let i = 0; i < node.childNodes.length; i++) {
              traverseNodes(node.childNodes[i]);
              if (charCount >= maxLength) break;
            }
            truncated += `</${node.tagName.toLowerCase()}>`;
          }
        };
      
        for (let i = 0; i < tempDiv.childNodes.length; i++) {
          traverseNodes(tempDiv.childNodes[i]);
          if (charCount >= maxLength) break;
        }
      
        return truncated;
      }

      function getWordCountFromHTMLAndCalculateReadTime(htmlContent) {
        // Create a temporary div element to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
      
        // Extract the text from the div (this removes all the tags)
        const text = tempDiv.innerText || tempDiv.textContent;
      
        // Split the text into words, filter out any empty strings, and count the words
        const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      
        const wordsPerMinute = 200; // Average reading speed
          const minutes = Math.ceil(words.length / wordsPerMinute); // Round up to nearest minute
          return `-${minutes} min`;
      
        // return words.length;
      }

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);


  


  return (
    <>
    {isLoading?<LastBlogDetails/>:
    <div className="shadow-xl rounded-[36px]">
    <div className="p-3">
      <Image src={blogs?.blogImageUrl} alt="online campus placement" width={500}  height={500} className="w-full h-[70vh]" />
    </div>
    <div className="py-8">
      <h4 className="mb-4 px-8 ">
      {capitalizeFirstLetter(blogs?.blogTitle)}
      </h4>
      <div className="my-3 flex px-6">
        <div className="mt-1">
          <Image src={logoeasycampus} alt="campus placement automation software" className="w-12 h-12" />
        </div>
        <div className="mt-2 ml-[4px]">
          <p className="text-[14px] ml-[2px]">Easy Campus</p>
          <p className="text-[14px]">{dateFormatForUser(blogs?.created_at)} {getWordCountFromHTMLAndCalculateReadTime(blogs?.blogDescription)}</p>
        </div>
      </div>
     

      <div className='font-semibold mt-2 px-8 text-justify' 
                      dangerouslySetInnerHTML={{
                        __html: capitalizeFirstLetter(truncateHtml(
                          decodeHtml(blogs?.blogDescription),
                          120
                        )),
                      }}
                    />

      <div className='text-right px-8 '>
        <Link href={`/blog/${blogs?.blogUrl}`}>
          <button className=" mt-2 text-right right-0 justify-end comic-button font-medium overflow-hidden  px-4 py-2 rounded-md hover:brightness-150  active:opacity-75 outline-none duration-300 group">
            <span className="bg-teal-700 shadow-teal-700 absolute -top-[150%] right-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
            Read More
          </button>
         
        </Link>
      </div>

    </div>
  </div >
    }
    
    </>
  )
}

export default LastBlog